import { ErrorHandler, Injectable } from '@angular/core';
import { isChunkLoadFailure, reportError } from './error-reporter';

/**
 * Uncaught exceptions and unhandled promise rejections (zone.js routes both
 * here). Still logs to the console exactly as Angular's default handler does.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  handleError(error: unknown): void {
    console.error(error);
    const e: any = (error as any)?.rejection ?? error;
    const message = String(e?.message || e);
    reportError({
      kind: isChunkLoadFailure(message) ? 'chunk_load' : 'exception',
      message,
      stack: e?.stack
    });
  }
}
